import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root' // Esto asegura que el servicio esté disponible en toda la aplicación
})
export class RouteReuseService {
    private shouldReuseRoutes = true;

    setReuseRoutes(shouldReuse: boolean) {
        this.shouldReuseRoutes = shouldReuse;
    }

    getReuseRoutes(): boolean {
        return this.shouldReuseRoutes;
    }
}
